import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import css from './styles.module.scss';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { getUserProfileData } from '~/features/dashboard/store/selectors';
import { getUserProfile } from '~/features/dashboard/store/actions.thunks';
import classNames from 'classnames';
import { createStyles, Grid, IconButton, ListItem, ListItemText, makeStyles, Popover, Theme, Typography } from '@material-ui/core';
import List from '@material-ui/core/List';
import { ProfileInput } from '../profile-input';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { axiosInstance } from '~/api/config/axios.config';
import { UserProfile } from '~/models/profile/UserProfile.dto';
import Button from '@material-ui/core/Button';
import { Loader } from '~/common/loader';
import { AutocompleteRenderInputParams } from '@material-ui/lab';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import { TextFieldOutlined } from '~/common/text-field-outlined';



interface ContentProps {
    user: any;
    tab: number;
    changeData: any;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        popover: {
            pointerEvents: 'none',
        },
        popoverContent: {
            pointerEvents: 'auto',
        },
        root: {
            width: '100%',
            maxWidth: 360,
            backgroundColor: theme.palette.background.paper,
        },
        large: {
            width: theme.spacing(20),
            height: theme.spacing(20),
            margin: 'auto',
        },
    })
);

export const ProfileDefaults: React.FC<ContentProps> = ({ user, tab, changeData }) => {
    const classes = useStyles();
    const dispatch = useThunkDispatch();

    const [isEditForm, setIsEditForm] = useState(false);
    const [userProfile, setUserProfile] = useState(new UserProfile());
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [piSociety, setPiSociety] = useState<{ affiliation: string }[]>([
        {
            affiliation: 'ABRAMUS',
        },
    ]);


    const userProfileResponse = useSelector(getUserProfileData);
    useMemo(() => {
        if(userProfileResponse){
            setUserProfile(userProfileResponse);
        }
        return userProfileResponse;
    }, [userProfileResponse]);

    useEffect(() => {

        axiosInstance.get('Catalogue/projectReference/ipisociety/list').then(data => {
            let data1 = data.data.filter((item: any) => {
                if (
                    item.affiliation === '' ||
                    item.affiliation === null ||
                    item.affiliation === undefined ||
                    item.definition === '' ||
                    item.definition === null ||
                    item.definition === undefined
                ) {
                    return false;
                } else {
                    return item;
                }
            });
            let piSocietyArray: any[] = [];
            data1.map((item: any) => piSocietyArray.push(item.affiliation));
            setPiSociety(piSocietyArray);
        });

        dispatch(getUserProfile());
    }, [dispatch]);


    const elementFocus = (ref: any) => {
        if (ref) {
            ref.current.focus();
        }
    };

    const updateData = (name: string, value: any) => {
        if (name) {
            setUserProfile({ ...userProfile, [name]: value });
        }
    };

    const open = Boolean(anchorEl);
    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const editContactForm = () => {
        setIsEditForm(true);
    };

    const submitForm = () => {
        setIsEditForm(false);
        setIsLoading(true)
        let data = userProfile;
        axiosInstance
            .put('catalogue/projectCreator/userProfile/save', {
                ...data,
            })
            .then((res) => {
                setUserProfile(res.data);
                setIsLoading(false);
                dispatch(getUserProfile());
            });
    };

    const cancelForm = () => {
        setIsLoading(true)
        dispatch(getUserProfile());
        setIsEditForm(false);
        setIsLoading(false)
    }

    return (
        <div className={css.module}>

            {
                isLoading ? (
                    <Loader className={css.loader}/>
                ) : (

                    <>

                        <Grid container className={css.avatarContainer}>

                            {
                                isEditForm ? (

                                    <>

                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs>
                                                    <ProfileInput
                                                        name='defaultArtistName'
                                                        label='Artist Name'
                                                        value={userProfile?.defaultArtistName}
                                                        isPadding={false}
                                                        elementFocus={elementFocus}
                                                        updateData={updateData}
                                                        isDisabled={false}
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    <ProfileInput
                                                        name='defaultWriterName'
                                                        label='Writer Name'
                                                        value={userProfile?.defaultWriterName}
                                                        isPadding={true}
                                                        elementFocus={elementFocus}
                                                        updateData={updateData}
                                                        isDisabled={false}
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    <Autocomplete
                                                        options={piSociety}
                                                        fullWidth
                                                        value={userProfile?.affiliation}
                                                        renderInput={(p: AutocompleteRenderInputParams) => (
                                                            <TextFieldOutlined {...p} label="Society" />
                                                        )}
                                                        onChange={(_, data) => updateData('affiliation', data)}
                                                        className={css.inputCurrency}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs>
                                                    <ProfileInput
                                                        name='defaultPublisherName'
                                                        label='Publisher Name'
                                                        value={userProfile?.defaultPublisherName}
                                                        isPadding={false}
                                                        elementFocus={elementFocus}
                                                        updateData={updateData}
                                                        isDisabled={false}
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    {/* TODO: show dropdown here */}
                                                    <ProfileInput
                                                        name='defaultAka'
                                                        label='AKA'
                                                        value={userProfile?.defaultAka}
                                                        isPadding={true}
                                                        elementFocus={elementFocus}
                                                        updateData={updateData}
                                                        isDisabled={false}
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    <ProfileInput
                                                        name='iPINumber'
                                                        label='IPI/CAE number'
                                                        value={userProfile?.iPINumber}
                                                        isPadding={true}
                                                        elementFocus={elementFocus}
                                                        updateData={updateData}
                                                        isDisabled={false}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs>
                                                    <ProfileInput
                                                        name='defaultLabel'
                                                        label='Label'
                                                        value={userProfile?.defaultLabel}
                                                        isPadding={false}
                                                        elementFocus={elementFocus}
                                                        updateData={updateData}
                                                        isDisabled={false}
                                                    />
                                                </Grid>
                                                <Grid item xs />
                                                <Grid item xs />
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Button variant="contained" className={css.submitBtn} onClick={submitForm}>Submit</Button>
                                            <Button variant="contained" className={css.cancelBtn} onClick={cancelForm}>Cancel</Button>
                                        </Grid>
                                    </>

                                ) : (

                                    <>
                                        <Grid item xs={12} className={css.marginTopContainer}>
                                            <Grid container>
                                                <Grid item xs>
                                                    <Typography className={classNames(css.bold, css.infoTitle)}>Artist Name</Typography>
                                                    <Typography className={classNames(css.infoContent)}>{userProfile?.defaultArtistName}</Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Typography className={classNames(css.bold, css.infoTitle)}>Writer Name</Typography>
                                                    <Typography className={classNames(css.infoContent)}>{userProfile?.defaultWriterName}</Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Typography className={classNames(css.bold, css.infoTitle)}>Society</Typography>
                                                    <Typography className={classNames(css.infoContent)}>{userProfile?.affiliation}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} className={css.marginTopContainer}>
                                            <Grid container>
                                                <Grid item xs>
                                                    <Typography className={classNames(css.bold, css.infoTitle)}>Publisher Name</Typography>
                                                    <Typography className={classNames(css.infoContent)}>{userProfile?.defaultPublisherName}</Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Typography className={classNames(css.bold, css.infoTitle)}>AKA</Typography>
                                                    <Typography className={classNames(css.infoContent)}>{userProfile?.defaultAka}</Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Typography className={classNames(css.bold, css.infoTitle)}>IPI/CAE number</Typography>
                                                    <Typography className={classNames(css.infoContent)}>{userProfile?.iPINumber}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} className={css.marginTopContainer}>
                                            <Grid container>
                                                <Grid item xs>
                                                    <Typography className={classNames(css.bold, css.infoTitle)}>Label</Typography>
                                                    <Typography className={classNames(css.infoContent)}>{userProfile?.defaultLabel}</Typography>
                                                </Grid>
                                                <Grid item xs />
                                                <Grid item xs />
                                            </Grid>
                                        </Grid>
                                    </>

                                )
                            }

                        </Grid>


                        <IconButton
                            className={classNames(css.editIcon)}
                            aria-label="add to favorites"
                            aria-owns={open ? 'mouse-over-popover' : undefined}
                            aria-haspopup="true"
                            onMouseEnter={handlePopoverOpen}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Popover
                            id="mouse-over-popover"
                            className={classes.popover}
                            classes={{
                                paper: classes.popoverContent,
                            }}
                            open={open}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                            PaperProps={{ onMouseLeave: handlePopoverClose }}
                        >
                            <List component="nav" className={classes.root} aria-label="contacts">
                                <ListItem button onClick={editContactForm}>
                                    <ListItemText primary="Edit" />
                                </ListItem>
                            </List>
                        </Popover>
                    </>

                )
            }

        </div>
    );
};
